var getQueryParam = require("../helpers/viewmodels").getQueryParam

function VirtualScrollQueue(queueModel) {
  var self = this;
  self.queueModel = queueModel;

  Object.setPrototypeOf(self, self.queueModel)

  self.virtualScrollingFirstBatchSize = 80;
  self.virtualScrollingBatchSize = 10;
  self.virtualScrollingStart = 0;
  self.virtualScrollingEnd = self.virtualScrollingBatchSize;
  self.virtualSpots = ko.observableArray([]);
  self.isVirtualScrollEnabled = false;

  if (getQueryParam('enableLazyLoad') === 'true') {
    self.isVirtualScrollEnabled = true;
  }

  self.queueModel.spots.subscribe(function (data) {
    self.virtualScrollingEnd = self.virtualScrollingFirstBatchSize;
    self.getVirtualScrollNextChunk(data);
  });

  self.virtualScrollingSpots = ko.computed(function () {
    if (self.isVirtualScrollEnabled) {
      return self.virtualSpots();
    }
   
    return queueModel.spots();
  })

  self.getVirtualScrollNextChunk = function(data) {
    self.virtualSpots(data.slice(self.virtualScrollingStart,  self.virtualScrollingEnd));
  }

  self.handleConsumerListScroll = function(data, event) {
    var elem = event.target;

    if (elem.scrollTop > (elem.scrollHeight - elem.offsetHeight - 200)) {
      self.virtualScrollingEnd = self.virtualSpots().length + self.virtualScrollingBatchSize;
      self.getVirtualScrollNextChunk(self.spots());
    }
  }

  return self;
};

module.exports = VirtualScrollQueue
